var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdCertified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59.51,
    height: 75.712,
    viewBox: "0 0 59.51 75.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.099,
    y1: 0.872,
    x2: 0.857,
    y2: 0.872,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cab56d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edd47a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "quality",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_250",
    "data-name": "Caminho 250",
    d: "M84.736,26.781,78.979,20.83l1.16-8.2A2.347,2.347,0,0,0,78.22,9.993l-8.155-1.43L66.183,1.248a2.347,2.347,0,0,0-3.1-1.008L55.642,3.875,48.2.239a2.347,2.347,0,0,0-3.1,1.009l-3.88,7.315-8.156,1.43a2.347,2.347,0,0,0-1.919,2.641l1.159,8.2-5.758,5.951a2.347,2.347,0,0,0,0,3.264L32.3,36l-1.159,8.2a2.347,2.347,0,0,0,1.919,2.64l6.527,1.144V73.365a2.347,2.347,0,0,0,3.4,2.1l12.655-6.325L68.3,75.465a2.347,2.347,0,0,0,3.4-2.1V47.982l6.527-1.145A2.347,2.347,0,0,0,80.139,44.2L78.979,36l5.757-5.95A2.347,2.347,0,0,0,84.736,26.781ZM56.692,64.416a2.347,2.347,0,0,0-2.1,0L44.285,69.568V54.044l.815,1.536a2.347,2.347,0,0,0,3.1,1.008l7.438-3.638,7.436,3.638a2.346,2.346,0,0,0,3.1-1.008L67,54.046V69.568Zm18.115-30.86a2.347,2.347,0,0,0-.637,1.961l1,7.089-7.048,1.236a2.348,2.348,0,0,0-1.668,1.211L63.1,51.374,56.674,48.23a2.347,2.347,0,0,0-2.063,0l-6.429,3.144-3.354-6.321a2.346,2.346,0,0,0-1.668-1.212l-7.049-1.236,1-7.089a2.347,2.347,0,0,0-.637-1.961L31.5,28.413l4.976-5.144a2.348,2.348,0,0,0,.637-1.961l-1-7.084,7.049-1.236a2.348,2.348,0,0,0,1.668-1.212l3.354-6.323L54.612,8.6a2.347,2.347,0,0,0,2.061,0L63.1,5.454l3.356,6.323a2.348,2.348,0,0,0,1.668,1.212l7.048,1.236-1,7.084a2.348,2.348,0,0,0,.637,1.961l4.976,5.144Z",
    transform: "translate(-25.886 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_251",
    "data-name": "Caminho 251",
    d: "M85.728,39.507a16.051,16.051,0,1,0,16.05,16.049A16.069,16.069,0,0,0,85.728,39.507Zm0,27.408A11.357,11.357,0,1,1,97.084,55.556,11.371,11.371,0,0,1,85.728,66.915Z",
    transform: "translate(-55.972 -27.144)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_252",
    "data-name": "Caminho 252",
    d: "M106.449,70.256l-6.933,6.932-2.638-2.635a2.347,2.347,0,1,0-3.317,3.321l4.3,4.293a2.347,2.347,0,0,0,3.318,0l8.592-8.59a2.347,2.347,0,0,0-3.319-3.32Z",
    transform: "translate(-71.909 -47.798)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdCertified);
export default __webpack_public_path__ + "static/media/mdCertified.0759591513608886aa9ad3be158b4e09.svg";
export { ForwardRef as ReactComponent };